
export enum AnalysisFeedbackTypes {
	RECORDING = 'RECORDING',
	TEXT_NOTE = 'TEXT_NOTE',
	ARROW = 'ARROW',
	HIGHLIGHT = 'HIGHLIGHT',
	LINE = 'LINE',
	SHAPE_SQUARE = 'SHAPE_SQUARE',
	SHAPE_CIRCLE = 'SHAPE_CIRCLE'
}

/**
 * Data for a text feedback
 * str: string - string text
 */
export type AnalysisFeedbackDataText = {
	str: string
}

/**
 * Data for an arrow feedback
 * x: number - x position as video area relative width 0-1
 * y: number - y position as video area relative height 0-1
 */
export type AnalysisFeedbackDataArrow = {
	x: number,
	y: number
}


/**
 * Data for angle between 2 lines
 * points: arr of 3 x,y points making up 2 lines with an angle between them
 */
export type AnalysisFeedbackDataAngle = {
	points: {x: number, y:number}[]
}

/**
 * Data for angle between 2 lines
 * points: arr of 3 x,y points making up 2 lines with an angle between them
 */
export type AnalysisFeedbackDataLine = {
	startPoint: {x: number, y:number},
	endPoint: {x: number, y:number}
}

/**
 * Data for shape(rectangle) draw area
 * rect: {x,y,width,height} - rectangle 
 */
export type AnalysisFeedbackDataShapeRectangle = {
	x: number,
	y: number,
	width: number,
	height: number
}

export type AnalysisFeedbackDataRecording = {
	src: string
}

/**
 * Feddback data
 * type: Feedback data type used to identify how to handle data
 * time: number - time in the video where this feedback should start
 * duration: number - how long the data is and should delay video playback
 * data: ... Object storing the data for this feedback
 */
export type AnalysisFeedback = {
	type: AnalysisFeedbackTypes,
	time: number,
	duration: number,  
	data: AnalysisFeedbackDataText | AnalysisFeedbackDataArrow | AnalysisFeedbackDataLine | AnalysisFeedbackDataAngle | AnalysisFeedbackDataShapeRectangle | AnalysisFeedbackDataRecording | undefined
}

export type AnalysisData = {
	videoFileName: string,
	feedbacks: AnalysisFeedback[]
}